import { useMemo } from 'react';

import {
	usePsfSharePageData,
	usePsfSharePageFcm,
	usePsfSharePageFcmExperiments,
} from 'src/app/pages/psf/share/pageContext';
import type { PsfShareChannel } from 'src/app/pages/psf/share/shared/types';

export function usePsfOnlyShareChannels(): readonly PsfShareChannel[] {
	const { psfOnlyShareButtonList } = usePsfSharePageFcm();

	const {
		data: { isTiktokChannelEnabled },
	} = usePsfSharePageData();

	const {
		redditExperiment: { variation: redditVariation },
		instagramStoriesExperiment: { variation: instagramStoriesVariation },
	} = usePsfSharePageFcmExperiments();

	const channelsToRemove = useMemo(() => {
		const result: PsfShareChannel[] = [];
		if (instagramStoriesVariation !== 'stories') {
			result.push('instagramStories');
		}
		if (redditVariation !== 'reddit') {
			result.push('reddit');
		}
		if (!isTiktokChannelEnabled) {
			result.push('tiktok');
		}

		return result;
	}, [redditVariation, instagramStoriesVariation, isTiktokChannelEnabled]);

	if (channelsToRemove.length !== 0) {
		return psfOnlyShareButtonList.filter((x) => !channelsToRemove.includes(x));
	}

	return psfOnlyShareButtonList;
}
